module.exports = __webpack_public_path__ + "img/money.1f989b7a.svg";